module.exports = __webpack_public_path__ + "static/media/achievement.08cd23ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PromotionCards/achievement.jpg
// module id = 816
// module chunks = 0